import React, { useMemo } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// 自訂組件 (依你的專案結構)
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useTranslation } from "react-i18next";

function MarketDataAnalysisBK() {
  const { t } = useTranslation("common");
  // 安全偵測 window 寬度
  const deviceType = useMemo(() => {
    if (typeof window !== "undefined" && window.innerWidth <= 768) {
      console.log("mobile");
      return "mobile";
    }
    console.log("desktop");
    return "desktop";
  }, []);

  const url = `https://app.appsmith.com/app/application/page1-6900634abf7a3d622c5d6788?embed=true&hide_navigation_bar=true&device=${deviceType}`;

  // 根據裝置調整 iframe 高度
  const iframeHeight = deviceType === "mobile" ? "1200px" : "800px";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {t("pageTitles.marketingDataAnalysis")}
                </MDTypography>
              </MDBox>

              <MDBox pt={3} px={0} width="100%">
                <iframe
                  src={url}
                  width="100%"
                  height={iframeHeight}
                  frameBorder="0"
                  style={{
                    borderRadius: "12px",
                    border: "none",
                    width: "100%",
                  }}
                  title="Appsmith Embed"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default MarketDataAnalysisBK;
